import { HS_PAXSCREENING_STATUS } from '../constants';
import { generateTotalLabNumbers } from '../utils';
import ModalShowViewAll from './ModalShowViewAll';
import {
  MincAdmin,
  DocumentIcon,
  CheckmarkIcon,
  Add,
  ReloadIcon,
  EditIcon,
} from '@/assets/svg';
import { ROLES_CAN_EDIT_LAB_NUMBER_IN_PROGRESS } from '@/constants/roles';
import { urlLabel } from '@/enum/PermissionEnum';
import { getNationalNumber } from '@/helpers';
import patientDispatcher from '@/module/patient/actions';
import { LAB_NUMBERS_MODES } from '@/new-components/CustomModal/ModalAssignLabNumber';
import customToast from '@/new-components/CustomNotification';
import CustomTooltip from '@/new-components/CustomTooltip';
import { Drawer, IconButton, Tooltip } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';
import { isEmpty } from 'lodash';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles({
  border: {
    height: 1,
    width: '100%',
    margin: '8px 0',

    backgroundImage: 'linear-gradient(to right, #C1C1C1 50%, transparent 50%)',
    backgroundPosition: 'top',
    backgroundSize: '10px 1px',
    backgroundRepeat: 'repeat-x',
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 20,
  },
  documentTitleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  totalCostWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    color: '#AD5E99',
    fontSize: 16,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  iconSurvey: {
    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: '#ffffff',
  },
  content: {
    margin: 0,
  },
});

const rowStyles = makeStyles({
  title: {
    paddingBottom: 10,
    minWidth: 116,
    verticalAlign: 'top',
    fontWeight: 400,
    color: '#666666',
  },
  text: {
    paddingBottom: 10,
    fontSize: 16,
    verticalAlign: 'top',
  },
  icon: {
    verticalAlign: 'middle',
    marginRight: 8,
    color: '#666666',
    width: 24,
    height: 24,
  },
});

const iconSurveyStyles = makeStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: '#ffffff',
  },
  circle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    width: 24,
    height: 24,
    borderRadius: 12,
  },
});

const CustomCard = withStyles({
  root: {
    padding: 20,
    boxShadow: 'none',
    borderRadius: 16,
    overflow: 'auto',
    backgroundColor: (props) => (props.color ? props.color : '#F6F6F6'),
    width: (props) => (props.width ? props.width : 'unset'),
  },
})(Card);

const CustomButton = withStyles({
  root: {
    minWidth: 'unset',
    height: 20,
  },
})(Button);

const RowHeaderItem = ({ title, icon, renderButton }) => {
  const Icon = icon;
  const classes = rowStyles();
  return (
    <th colSpan={3} className={classes.title} style={{ fontSize: 20 }}>
      <th
        colSpan={2}
        className={classes.title}
        style={{ fontSize: 20, fontWeight: 500 }}
      >
        {icon && <Icon className={classes.icon} />}
        <span style={{ verticalAlign: 'middle', color: '#333333' }}>
          {title}
        </span>
      </th>
      <td style={{ verticalAlign: 'middle' }}>
        {renderButton && renderButton()}
      </td>
    </th>
  );
};

const RowItem = ({ children, title }) => {
  const classes = rowStyles();

  if (typeof children === 'object') {
    return (
      <tr>
        <td className={classes.title}>{title}</td>
        <td className={classes.text}>{children}</td>
      </tr>
    );
  }

  return (
    <tr>
      <td className={classes.title}>{title}</td>
      {children === 'None' ? (
        <td className={classes.text} style={{ color: '#999999' }}>
          {children}
        </td>
      ) : (
        <td className={classes.text}>
          <CustomTooltip content={children} />
        </td>
      )}
    </tr>
  );
};

const CustomIconCheckmark = ({ isDone }) => {
  const classes = iconSurveyStyles();

  return (
    <div className={classes.wrapper}>
      <div
        className={classes.circle}
        style={{
          backgroundColor: isDone ? '#0B8E5E' : '#999999',
        }}
      >
        <CheckmarkIcon />
      </div>
    </div>
  );
};

const GeneralInformation = ({
  dataInfor,
  projectInfor,
  currentLabNumber,
  totalLabNumbers,
  onOpenEditStaffType,

  lifestyleSurvey,
  customSurvey,
  consetForms,
  isFollowUp,
  setShowAddLabNumber,
  totalTestCodes,
  isAfterRegistration,
  staffType,
  setShowAssignLabNumber,
  setLabNumbersMode,
  onAssignLabNumber,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [showViewAll, setShowViewAll] = useState(false);

  const renderTooltipData = (data, maxLength = 25) => {
    const lstTotalData = [...data];

    const strData = data.join(', ');

    let shortStrData = '';
    if (strData && strData.length >= maxLength) {
      shortStrData = (lstTotalData[0] + ', ' + lstTotalData[1] || '') + ',...';
    }

    return shortStrData ? (
      <Tooltip
        title={
          <p style={{ color: '#fff', margin: 0, fontSize: 16 }}> {strData}</p>
        }
      >
        <p className={classes.content}> {shortStrData}</p>
      </Tooltip>
    ) : (
      <p className={classes.content}> {strData}</p>
    );
  };

  const { roleName } = useSelector((state) => state.auth.userInfo) || {};

  const isCompleted =
    dataInfor?.paxScreenStatus === HS_PAXSCREENING_STATUS.Completed;

  /**
   * Whether the lab number is entered by hand through the popup, as opposed to
   * being auto-generated. Completed screenings always are; an In Progress one
   * only for the roles allowed to correct a number mid-screening.
   */
  const isManualLabNumber =
    isCompleted ||
    (dataInfor?.paxScreenStatus === HS_PAXSCREENING_STATUS.InProgress &&
      ROLES_CAN_EDIT_LAB_NUMBER_IN_PROGRESS.includes(roleName));

  useEffect(() => {
    if (!dataInfor?.mobile || !dataInfor?.countryCode) return;

    const isValidMobile = isValidPhoneNumber(
      dataInfor?.mobile,
      dataInfor?.countryCode
    );

    if (!isValidMobile) {
      customToast(
        'error',
        "The patient's mobile number is invalid. Please click 'View' to update it.",
        'Mobile number invalid',
        true,
        () => {
          patientDispatcher.getPatientListBySearch(
            dataInfor.email,
            (result) => {
              history.push({
                pathname: `/${urlLabel.editUserDetail}`,
                state: result.list[0],
              });
            }
          );
        }
      );
      history.goBack();
    }
  }, [dataInfor, history]);

  return (
    <>
      <CustomCard color="#e2f2ffb3" width={360}>
        <table style={{ width: '100%' }}>
          <RowHeaderItem title="Patient info" icon={MincAdmin} />
          <RowItem title="Name">{dataInfor?.fullName || 'None'}</RowItem>
          <RowItem title="NRIC">{dataInfor?.identityNumber || 'None'}</RowItem>
          <RowItem title="Date of birth">
            {dataInfor?.dateOfBirth
              ? moment(dataInfor?.dateOfBirth).format('DD/MM/YYYY')
              : 'None'}
          </RowItem>
          <RowItem title="Ethnic group">
            {dataInfor?.ethnicGroup || 'None'}
          </RowItem>
          <RowItem title="Phone number">
            {dataInfor?.mobile &&
            isValidPhoneNumber(dataInfor?.mobile, dataInfor?.countryCode)
              ? parsePhoneNumber(
                  getNationalNumber(
                    dataInfor?.mobile,
                    dataInfor?.countryCode,
                    true
                  )
                ).formatInternational()
              : 'None'}
          </RowItem>
          <RowItem title="Email">{dataInfor?.email || 'None'}</RowItem>
          <RowItem title="Company">
            {projectInfor?.companyName || 'None'}
          </RowItem>
          <RowItem title="Staff type">
            <Box display="flex" justifyContent="space-between" width="100%">
              {staffType ? (
                <>
                  <CustomTooltip content={staffType.type} />
                  {!isFollowUp && (
                    <IconButton
                      color="primary"
                      style={{ padding: 0 }}
                      onClick={onOpenEditStaffType}
                      hidden={isAfterRegistration}
                    >
                      <EditIcon />
                    </IconButton>
                  )}
                </>
              ) : (
                '—'
              )}
            </Box>
          </RowItem>
          <RowItem title="Test codes">
            {!isEmpty(totalTestCodes)
              ? renderTooltipData(totalTestCodes, 20)
              : 'None'}
          </RowItem>
          {isFollowUp ? null : (
            <RowItem title="PM code">{dataInfor?.pmCode || 'None'}</RowItem>
          )}
          {isFollowUp ? null : (
            <RowItem title="Lab number">
              {currentLabNumber ? (
                <Box display="flex" justifyContent="space-between" width="100%">
                  {renderTooltipData(generateTotalLabNumbers(totalLabNumbers))}
                  <Box>
                    <IconButton
                      color="primary"
                      style={{ padding: 0 }}
                      onClick={() => {
                        if (isManualLabNumber) {
                          setLabNumbersMode(LAB_NUMBERS_MODES.ManualEdit);
                          setShowAssignLabNumber(true);
                        } else {
                          onAssignLabNumber(projectInfor?.labProvider);
                          setLabNumbersMode(LAB_NUMBERS_MODES.AutoEdit);
                        }
                      }}
                    >
                      <ReloadIcon />
                    </IconButton>
                  </Box>
                </Box>
              ) : (
                <CustomButton
                  size="small"
                  color="primary"
                  startIcon={<Add />}
                  onClick={() => {
                    if (isManualLabNumber) {
                      setLabNumbersMode(LAB_NUMBERS_MODES.ManualAssign);
                      setShowAssignLabNumber(true);
                    } else {
                      onAssignLabNumber(projectInfor?.labProvider);
                    }
                  }}
                >
                  Assign
                </CustomButton>
              )}
            </RowItem>
          )}
        </table>
        <div className={classes.border}></div>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.documentTitleWrapper}>
            <Typography className={classes.title}>
              <DocumentIcon style={{ marginRight: 8 }} />
              Documents
            </Typography>
            <CustomButton
              style={{ color: '#3776AB' }}
              onClick={() => setShowViewAll(!showViewAll)}
            >
              View all
            </CustomButton>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gridGap={8}>
              <CustomIconCheckmark isDone={dataInfor?.isSignedConsentForm} />
              Consent Form
            </Box>
          </Grid>
          {/* <Grid item xs={12}>
            <Box display="flex" alignItems="center" gridGap={8}>
              <CustomIconCheckmark
                isDone={dataInfor?.isCompletedCustomSurvey}
              />
              Custom survey
            </Box>
          </Grid> */}
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" gridGap={8}>
              <CustomIconCheckmark isDone={dataInfor?.isCompletedSurvey} />
              Lifestyle survey
            </Box>
          </Grid>
        </Grid>
      </CustomCard>
      {showViewAll && (
        <Drawer
          anchor="right"
          open={showViewAll}
          onClose={() => setShowViewAll(false)}
          disableBackdropClick
          PaperProps={{
            style: {
              width: '50%',
              minWidth: 768,
            },
          }}
        >
          <ModalShowViewAll
            dataInfor={dataInfor}
            lifestyleSurvey={lifestyleSurvey}
            customSurvey={customSurvey}
            consetForms={consetForms}
            onClose={() => {
              setShowViewAll(false);
            }}
          />
        </Drawer>
      )}
    </>
  );
};

export default GeneralInformation;
